import api from '@/services/api'
import { useLocalStorage, useSessionStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'
import type { Friend } from '@/types/referral'
import { computed, ref } from 'vue'
import { useNow } from '@/composables/game/time'
import { DateTime } from 'luxon'

export const useReferredFriends = () => {
  const { now } = useNow()

  const playerFriends = useSessionStorage<Friend[]>(buildDropeeStorageKey('playerFriends'), [])

  const playerPokes = useSessionStorage<string[]>(buildDropeeStorageKey('playerPokes'), [])
  const pokeMemory = useLocalStorage<{timestamp: string, count: number}>(buildDropeeStorageKey('pokeMemory'), { timestamp: '', count: 0 })

  const pokeLimit = ref(5)
  const friendsCount = ref<number>(0)
  const referralsCount = ref<number>(0)
  const virtualFriendIdPrefix = ref<string>('virtual')

  const remainingTimeToPoke = computed(() => pokeMemory.value.timestamp ? (DateTime.fromISO(pokeMemory.value.timestamp).plus({ minutes: 10 }).toSeconds()) - now.value : 0)

  async function getFriends(refresh = false) {
    const {
      friends: friendList,
      pokes,
      virtualFriendIdPrefix: virtualPrefix,
      friendsCount: friends,
      referralsCount: referrals,
    } = await api.getFriends()
    playerFriends.value = friendList.sort((a, b) => b.profit - a.profit)
    playerPokes.value = pokes
    friendsCount.value = friends ?? 0
    referralsCount.value = referrals ?? 0
    virtualFriendIdPrefix.value = virtualPrefix
  }

  return {
    playerFriends,
    getFriends,
    playerPokes,
    friendsCount,
    referralsCount,
    virtualFriendIdPrefix,
    remainingTimeToPoke,
    pokeMemory,
    pokeLimit,
  }}
